var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMpStepFinishFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 36,
    viewBox: "0 0 75 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5196 18.0835C40.5196 18.0835 42.7781 17.4839 47.0738 19.9409C51.3694 22.3979 52.5798 26.873 56.8754 29.3299C61.171 31.7869 63.4296 31.1874 63.4296 31.1874L73.3499 14.1649C73.3499 14.1649 71.0914 14.7644 66.7957 12.3075C62.5001 9.85047 61.2897 5.3754 56.9941 2.91842C52.6985 0.461435 50.4399 1.06098 50.4399 1.06098L40.5196 18.0835Z",
    fill: "#00796B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5196 18.0835C40.5196 18.0835 42.7781 17.4839 47.0738 19.9409C51.3694 22.3979 52.5798 26.873 56.8754 29.3299C61.171 31.7869 63.4296 31.1874 63.4296 31.1874L73.3499 14.1649C73.3499 14.1649 71.0914 14.7644 66.7957 12.3075C62.5001 9.85047 61.2897 5.3754 56.9941 2.91842C52.6985 0.461435 50.4399 1.06098 50.4399 1.06098L40.5196 18.0835ZM40.5196 18.0835L30.9299 34.5385",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8339 18.0835C33.8339 18.0835 31.5754 17.4839 27.2797 19.9409C22.9841 22.3979 21.7737 26.873 17.4781 29.3299C13.1825 31.7869 10.9239 31.1874 10.9239 31.1874L1.00358 14.1649C1.00358 14.1649 3.26215 14.7644 7.55778 12.3075C11.8534 9.85047 13.0638 5.3754 17.3594 2.91842C21.655 0.461435 23.9136 1.06098 23.9136 1.06098L33.8339 18.0835Z",
    fill: "#00796B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8339 18.0835C33.8339 18.0835 31.5754 17.4839 27.2797 19.9409C22.9841 22.3979 21.7737 26.873 17.4781 29.3299C13.1825 31.7869 10.9239 31.1874 10.9239 31.1874L1.00358 14.1649C1.00358 14.1649 3.26215 14.7644 7.55778 12.3075C11.8534 9.85047 13.0638 5.3754 17.3594 2.91842C21.655 0.461435 23.9136 1.06098 23.9136 1.06098L33.8339 18.0835ZM33.8339 18.0835L43.4236 34.5385",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpStepFinishFilled);
export default __webpack_public_path__ + "static/media/mp-step-finish-filled.83cc4547e2c090cb69b702bd5645a9de.svg";
export { ForwardRef as ReactComponent };